<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"><HeaderContent /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 动态详情 -->
      <div class="dynamic_details">
        <h1>蓝海购下半年工作经营会议在上海隆重召开</h1>
        <p class="author">
          <span><a>蓝海购</a></span
          ><span>2018-06-11</span>
        </p>
        <p>
          鸡蛋，从外打破是食物，从内打破是生命。人生亦是，从外打破是压力，从内打破是成长。唯有不断的自我突破，与目标较劲，跨越自我，才能迎来胜利的曙光！
        </p>
        <div class="dynamics_img">
          <img src="~@/assets/images/bos20.webp" />
        </div>
        <p>
          6月11日，一清早，蓝海购各城市公司负责人集结上海，就蓝海购下半年工作经营会议做了详尽的汇报及工作部署。与此同时，各方城市公司就目标签署了团队军令状。
        </p>
        <div class="dynamics_img">
          <img src="~@/assets/images/bos21.webp" />
        </div>
        <p>
          势如破竹，气势如虹!目标签订，势必达成！关乎指标，关乎荣誉，更关乎每一位蓝海购人！
        </p>
        <div class="dynamics_img">
          <img src="~@/assets/images/bos25.webp" />
        </div>
        <p>
          会议上各方城市公司负责人就上季度工作进行了详细的回顾，在深度剖析自我的同时，总结优势、规避风险，并迈向卓越。
        </p>
        <div class="dynamics_img">
          <img src="~@/assets/images/bos26.webp" />
        </div>
        <p>
          会议上,公司COO兼上海公司总经理郭光先生,就公司业务发展进行了深刻的传输。“蓝海购是一家可持续性发展企业，业务是公司存活的命脉，不是投机取巧、形式化，而是扎扎实实用数据说话，用质量取胜。将团队打造成顶尖的队伍，落定目标，达成目标。对于优秀的同事，我要给予丰厚的奖励，发扬“以奋斗有成就者为本”的企业核心价值观，要让员工的利益与公司的利益达成一致，与此同时，无论是前端还是后端，要通力合作，要锁定目标，加速达成，超越目标。”
        </p>
        <div class="dynamics_img1">
          <img src="~@/assets/images/bos28.gif" />
        </div>
        <p>黄沙百战穿金甲,不破楼兰终不还。全新的下季度，全新的高度！</p>
        <div class="dynamics_img">
          <img src="~@/assets/images/bos27.gif" />
        </div>
      </div>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  background: #f8fafc;
  .dynamic_details {
    // margin: 62px 260px 53px 260px;
    margin: 62px 232px 53px 254px;
    padding: 55px 67px 74px 61px;
    background: #fff;
    text-align: left;
    h1 {
      font-size: 30px;
      max-width: 677px;
      margin: 0 auto;
      text-align: left;
    }
    p {
      font-size: 16px;
      line-height: 32px;
      margin: 0 auto;
      max-width: 677px;
      margin-bottom: 10px;
    }

    > p:nth-of-type(2) {
      margin-top: 40px;
    }

    > p:nth-of-type(3) {
      margin-top: 10px;
    }

    > p:nth-of-type(7) {
      margin-bottom: 15px;
      margin-top: 30px;
    }

    div {
      text-align: center;
    }

    h3 {
      font-size: 20px;
      margin: 20px 0;
    }
    .author {
      margin-top: 10px;
      display: flex;
      span:nth-of-type(1) {
        margin-right: 10px;
      }
      img {
        vertical-align: middle;
        margin: 0 10px;
      }
      a {
        color: #999999;
        font-size: 14px;
      }
      > span:nth-of-type(2) {
        color: #999999;
      }
    }

    .dynamics_img {
      img {
        width: 677px;
        margin: 0 auto;
      }
    }

    .dynamics_img1 {
      margin-top: 40px;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>